<template>
    <div
        aria-live="assertive"
        class="pointer-events-none fixed max-w-[inherit] mx-auto top-20 inset-0 flex items-end py-6 sm:items-start px-6 z-50"
    >
        <div class="flex w-full flex-col items-center space-y-4 sm:items-end">
            <transition
                enter-active-class="transform ease-out duration-300 transition"
                enter-from-class="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
                enter-to-class="translate-y-0 opacity-100 sm:translate-x-0"
                leave-active-class="transition ease-in duration-100"
                leave-from-class="opacity-100"
                leave-to-class="opacity-0"
            >
                <div
                    v-if="showFlashMessage"
                    class="pointer-events-auto w-full max-w-sm overflow-hidden rounded-lg ring-1 ring-black ring-opacity-5 bg-primary text-primary-text relative shadow-sm shadow-primary-text"
                >
                    <div class="p-4">
                        <transition name="fade" mode="out-in">
                            <div :key="text" class="flex items-start">
                                <div
                                    class="ml-1 flex items-center w-full gap-x-5"
                                >
                                    <div
                                        class="rounded-full bg-danger/90 text-white"
                                        v-if="error"
                                    >
                                        <PhExclamationMark
                                            weight="bold"
                                            class="size-10 p-1"
                                        />
                                    </div>

                                    <PhInfo v-else class="size-10" />
                                    <p class="text-sm" v-text="text" />
                                </div>
                                <div class="ml-4 flex flex-shrink-0">
                                    <button
                                        type="button"
                                        class="inline-flex rounded-md"
                                        @click="close"
                                    >
                                        <span class="sr-only">Close</span>
                                        <PhX
                                            weight="bold"
                                            class="hover:transform hover:scale-125 transition-transform duration-200 size-5"
                                        />
                                    </button>
                                </div>
                            </div>
                        </transition>
                    </div>
                    <div
                        :class="[
                            'absolute bottom-0 h-1 bg-primary-text ',
                            progressStarted
                                ? 'w-0 transition-width duration-[5000ms] ease-linear'
                                : 'w-full',
                        ]"
                    />
                </div>
            </transition>
        </div>
    </div>
</template>

<script>
import { PhExclamationMark, PhInfo, PhX } from '@phosphor-icons/vue'
export default {
    components: {
        PhExclamationMark,
        PhInfo,
        PhX,
    },

    props: {
        message: {
            type: String,
            default: null,
        },
        error: {
            type: String,
            default: null,
        },
    },

    computed: {
        text() {
            return this.error ? this.error : this.message
        },

        showFlashMessage() {
            return !!this.error || !!this.message
        },
    },

    mounted() {
        if (this.showFlashMessage) {
            this.startCloseTimer()
        }
    },

    data() {
        return {
            progressStarted: false,
            closeTimer: null,
        }
    },

    watch: {
        text() {
            if (this.showFlashMessage) {
                this.startCloseTimer()
            }
        },
    },

    methods: {
        startCloseTimer() {
            if (this.closeTimer) {
                clearTimeout(this.closeTimer)
                this.progressStarted = false
            }

            this.$nextTick(() => {
                setTimeout(() => {
                    this.progressStarted = true
                }, 50)
            })

            this.closeTimer = setTimeout(() => {
                this.close()

                this.progressStarted = false
            }, 5000)
        },

        close() {
            this.progressStarted = false

            this.$emit('close')
        },
    },
}
</script>

<style scoped>
.pointer-events-none {
    position: fixed;
    right: 0;
    left: 0;
    width: 100%;
}
</style>
